// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__iwz10","label":"CategoryService_label__3NBet","location":"CategoryService_location__OzSzq"};